import { __generator } from "tslib";
import { call, select, takeLatest } from 'redux-saga/effects';
import { pickBy, keys } from 'lodash-es';
import * as actionCreators from '../actionCreators';
import * as actionTypes from '../constants/actionTypes';
import * as status from '../constants/imagePreloading';
import { preloadImages } from '../utils/image';
// It seems that sometimes pre-loaded images are dumped from the browser's memory
// when you change tab away from the prototype viewer.
// To combat this we trigger a reload of all the images that are DONE, ie
// those the application _think_ are loaded but may have been dumped out of memory
export default function reloadImages(dispatch) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actionTypes.RELOAD_IMAGES, function () {
                    var project, screensToReload, imagesToReload;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, select(function (state) { return state.project; })];
                            case 1:
                                project = _a.sent();
                                if (!project.config.screens) {
                                    // The visibility change event may fire before the project is loaded
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, select(function (state) {
                                        return pickBy(state.imagePreloading, function (value) { return value === status.RELOADING; });
                                    })];
                            case 2:
                                screensToReload = _a.sent();
                                imagesToReload = keys(screensToReload).map(function (screenID) { return ({
                                    id: screenID,
                                    url: project.config.screenMap[screenID].img.url,
                                }); });
                                // TODO not sure whether to batch these or not -- should be quick as reloading from cache
                                return [4 /*yield*/, call(preloadImages, {
                                        dispatch: dispatch,
                                        images: imagesToReload,
                                        successActionCreator: actionCreators.imageLoaded,
                                        failureActionCreator: actionCreators.imageLoadFailed,
                                    })];
                            case 3:
                                // TODO not sure whether to batch these or not -- should be quick as reloading from cache
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
